<template>
  <div id="wrapper">
    <div class="navbar navbar-default navbar-fixed-top">
      <div class="navbar-header">
        <a class="navbar-brand" href="/"><img src="/static/dist/images/GR-new+.png"></a>
        <!-- <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-main">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button> -->
      </div>
      <div class="collapse navbar-collapse" id="navbar-main">
        <ul class="nav navbar-top-links navbar-right">
          <!-- <li>
            <router-link to="/">Welcome</router-link>
          </li> -->
         <!--  <li>
            <a href="https://www.greeneum.net/company">Company</a>
          </li>
          <li>
            <a href="https://www.greeneum.net/greeneum-products">Services</a>
          </li>
          <li>
            <a href="https://www.greeneum.net/greeneum-community">Community</a>
          </li> -->
          <!-- <li>
            <router-link to="/contact">Contact</router-link>
          </li> -->
         <!--  <li>
            <a href="https://www.greeneum.net/green-affiliates" class="btn-green" target="_blank">Get GREEN</a>
          </li> -->
        </ul>
      </div>
    </div>

    <!-- Page Content -->
    <div id="page-content-wrapper">
        <div class="container-fuild">
            <div class="container">
                <div id="sidebar-wrapper">
                    <a href="/" class="left-logo"><img src="/static/dist/images/GR-new+.png"></a>
                    <div class="menu-left">
                      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-sidebar">
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                      </button>
                      <ul class="sidebar-nav sb-nav-top">
                            <li class="user">
                                <a href="/settings">
                                    <span class="user-photo">
                                        <img :src="userData && userData.image && userData.image != '' ? userData.image : '/static/zeplin/default-user.png'">
                                    </span>
                                    <span class="user-name">{{userData.fullName}}</span>
                                </a>
                            </li>
                        </ul>
                      <div class="collapse navbar-collapse" id="navbar-sidebar">
                        <ul class="sidebar-nav">
                          <li>
                            <router-link to="/dashboard">Dashboard</router-link>
                          </li>
                          <li v-if="userData.typeOfProfile!='investor'">
                            <router-link to="/projects?my=true">My Projects</router-link>
                          </li>
                          <li v-if="userData.typeOfProfile!='investor'">
                            <router-link to="/projects/public">Public Projects</router-link>
                          </li>
                          <li>
                            <router-link to="/greenfund">GREEN Fund</router-link>
                          </li>
                          <li>
                            <a href="https://www.greeneum.net/green-affiliates" target="_blank">Get GREEN</a>
                          </li>
                          <li>
                            <router-link to="/wallet">Wallets Explorer</router-link>
                          </li>
                          <li>
                            <a href="https://beta1.greeneum8.net/" target="_blank">SolarAPI</a>
                          </li>
                          <li>
                            <a href="https://www.greeneum-market.com/" target="_blank">Marketplace</a>
                          </li>
                          <li>
                            <router-link to="/settings">Settings</router-link>
                            <!-- <router-link to="/payment/edit">Settings</router-link> -->
                            <a v-on:click="signOut()" class="l-out">Log Out</a>
                          </li>

                        </ul>
                      </div>
                    </div>
                </div>
                <div class="content-box page-content project-page">
                  <slot/>
                </div>
            </div>
            <!-- <button v-on:click="backToGREEN()" type="button" class="btn btn-back">Back</button> -->
        </div>

        <!-- /#page-wrapper -->
    </div>
  </div>
</template>

<script>
import { Api, Toast, Helper } from './../services'

export default {
  name: 'LayoutMain',
  props: [],
  components: {
  },
  data() {
    return {
      userData: {},
    }
  },
  computed: {
  },
  methods: {
    async signOut() {
      await Api.signOut();
    },
    backToGREEN() {
      this.$router.go(-1);
    },
  },
  async created() {
    try {
      var response = await Api.myProfileSmallInfo()
      this.userData = response.data.user

    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      //this.$refs.progress.hide()
    }
  },
}

</script>



// WEBPACK FOOTER //
// src/layouts/LayoutMain.vue